import { render, staticRenderFns } from "./ProjectTeamMembers.vue?vue&type=template&id=0c70a217&scoped=true"
import script from "./ProjectTeamMembers.vue?vue&type=script&lang=js"
export * from "./ProjectTeamMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectTeamMembers.vue?vue&type=style&index=0&id=0c70a217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70a217",
  null
  
)

export default component.exports